module.exports = __webpack_public_path__ + "static/media/matching-score-coin-60.562bce29.png";